import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions/createOrderActions';
import * as appActions from '../actions/appActions';
import * as fleetActions from '../actions/fleetOwnerActions';
import FleetOrderCreationForm from '../components/orderCreation/OrderActionComponent';
import _ from 'lodash';
import LoopbackHttp from '../businessLogic/LoopbackHttp.js';
import isEmpty from '../businessLogic/isObjectEmpty.js';
import { getTeamsIds } from '../businessLogic/teamHelper';


export class FleetOrderCreationContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.items = [{ isFloating: false, isComment: false }];
    this.state = {};
    _.bindAll(this, []);
  }

  componentDidMount() {
    if ((LoopbackHttp.isFleet || LoopbackHttp.isOperator) && !isEmpty(this.props.orderForUpdate)
      && this.props.orderForUpdate.createdBy.role === 'dispatcher') {
      return this.props.actions.getDispatcherPoints(this.props.orderForUpdate.createdBy.id);
    }

    if (LoopbackHttp.isFleet) {
      this.props.actions.getTeamsForFleetOrderCreation(this.props.company.id);
    } else if (LoopbackHttp.isOperator)
      this.props.actions.getTeamsForOperatorOrderCreation(this.props.account.id);
    else if (LoopbackHttp.isDispatcher)
      this.props.actions.getDispatcherPoints(this.props.account.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.orderCreated && nextProps.orderCreated !== this.props.orderCreated) {
      // this.props.appActions.addNewRecipientToStore(nextProps.createdStuff.result.recipient);
      // this.props.appActions.addNewOrderToStore(objectAssign({}, nextProps.createdStuff.result.order, { items: nextProps.createdStuff.result.items }));
      // this.props.appActions.removeOrderForReturn();
      // this.props.appActions.endSpinner();
      return this.props.router.push('/');
    }

    if (nextProps.teams !== this.props.teams) {
      this.props.actions.getTeamsPoints(getTeamsIds(nextProps.teams));
    }

    if (nextProps.pickUpPoints !== this.props.pickUpPoints)
      this.setState({ pointsLoaded: true });
  }

  render() {
    let { orderForUpdate } = this.props;
    if (orderForUpdate && orderForUpdate.items)
      _.map(orderForUpdate.items, (item) => { delete item.pickUpPoint; });
    return this.state.pointsLoaded ? (
      <FleetOrderCreationForm
        vehicles={this.props.vehicles}
        showMessage={this.props.showMessage}
        pickUpPoints={this.props.pickUpPoints}
        orderForReturn={this.props.orderForReturn}
        orderForUpdate={this.props.orderForUpdate}
        createOrder={this.props.fleetActions.createOrder}
        updateOrder={this.props.appActions.updateOrderAndLog}
        startSpinner={this.props.appActions.startSpinner}
        recipients={this.props.recipients}
        company={this.props.company}
        account={this.props.account}
        getRecipient={this.props.appActions.getRecipient}
        fetched_recipient={this.props.fetched_recipient}
        router={this.props.router}
        removeOrderForUpdate={this.props.appActions.removeOrderForUpdate}
        removeOrderForReturn={this.props.appActions.removeOrderForReturn}
      />
    ) : null;
  }
}



FleetOrderCreationContainer.propTypes = {
  showMessage: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    pickUpPoints: state.orderCreationReducer.pickUpPoints,
    orderCreated: state.orderCreationReducer.orderCreated,
    recipient: state.orderCreationReducer.recipient,
    recipients: state.orderCreationReducer.recipients,
    order: state.orderCreationReducer.order,
    item: state.orderCreationReducer.item,
    vehicles: state.appReducer.vehicles,
    createdStuff: state.orderCreationReducer.createdStuff,
    account: state.appReducer.account,
    orderForReturn: state.appReducer.orderForReturn,
    orderForUpdate: state.appReducer.orderForUpdate,
    company: state.appReducer.company,
    fetched_recipient: state.appReducer.fetched_recipient,
    teams: state.orderCreationReducer.teams
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    appActions: bindActionCreators(appActions, dispatch),
    fleetActions: bindActionCreators(fleetActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FleetOrderCreationContainer);



// WEBPACK FOOTER //
// ./src/containers/FleetOrderCreationContainer.js